module.exports = __webpack_public_path__ + "src/images/sass-logo.74c362907475d0d7f0d59d0fb662135c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/sass-logo.png
// module id = 108
// module chunks = 0